/**
 * Format a date string as "01 Apr 2026"
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/**
 * Join items with ", " and " & " for the last item (e.g., "A, B & C")
 */
export function joinWithAmpersand(items: string[]): string {
  if (items.length <= 2) {
    return items.join(" & ");
  }
  return `${items.slice(0, -1).join(", ")} & ${items.at(-1)}`;
}

/**
 * Get the scheme badge color
 */
export function getSchemeBadgeColor(scheme: string): string {
  switch (scheme.toUpperCase()) {
    case "SCHEME FOR RELIEF EDUCATOR (SRE)":
      return "bg-red-100 text-red-700 border-red-200";
    case "FLEXI-ADJUNCT TEACHING SCHEME (FAJT)":
      return "bg-blue-100 text-blue-700 border-blue-200";
    case "CONTRACT ADJUNCT TEACHING SCHEME (CAJT)":
      return "bg-green-100 text-green-700 border-green-200";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200";
  }
}

/**
 * Available level options for filtering
 */
export const LEVEL_OPTIONS = [
  "P1",
  "P2",
  "P3",
  "P4",
  "P5",
  "P6",
  "Sec 1",
  "Sec 2",
  "Sec 3",
  "Sec 4",
  "Sec 5",
  "JC/MI 1",
  "JC/MI 2",
  "MI 3",
] as const;

/**
 * Note: should be in sync with subjects in forms
 */
export const SUBJECT_OPTIONS = [
  "English Language",
  "General Paper",
  "Mathematics",
  "Science",
  "Chemistry",
  "Biology",
  "Physics",
  "Chinese Language",
  "Malay Language",
  "Tamil Language",
  "Geography",
  "History",
  "Literature in English",
  "Physical Education",
  "Music",
  "Art",
  "Social Studies",
  "Character and Citizenship Education",
  "Design and Technology",
  "Food and Consumer Education",
  "Project Work",
  "Computing",
  "Elements of Business Skills",
  "Economics",
] as const;

/**
 * Available scheme options
 */
export const SCHEME_OPTIONS = ["SRE", "FAJT", "CAJT"] as const;

export const TERMS_OF_USE_URL = "https://go.gov.sg/matcher-termsofuse";
export const PRIVACY_POLICY_URL = "https://go.gov.sg/matcher-privacypolicy";
